module.exports = require('./helpers/bundle-url').getBundleURL('76NkK') + "logo-dark.ba5147f0.svg";